import React, { useState, useEffect } from 'react'; 
import '../Styles/AirPaxCalendar.css';


const AirPaxCalendar = () => {
    const [dates, setDates] = useState(generateInitialDates());
    const [currentDateIndex, setCurrentDateIndex] = useState(0);

    function generateInitialDates() {
      const today = new Date();
      const datesArray = [];
      for (let i = 0; i < 10; i++) {
          const date = new Date(today);
          date.setDate(today.getDate() + i);
          datesArray.push({
              day: date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
              date: date.getDate(),
              monthYear: date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }).toUpperCase(),
              isToday: i === 0,
          });
      }
      return datesArray;
  }
  
  const addDates = (start, end) => {
      const newDates = [];
      const today = new Date();
      
      for (let i = start; i < end; i++) {
          const date = new Date(today);
          date.setDate(today.getDate() + i);
          newDates.push({
              day: date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase(),
              date: date.getDate(),
              monthYear: date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' }).toUpperCase(),
              isToday: i === 0,
          });
      }
      
      return newDates;
  };
  
  const navigateDates = (direction) => {
    if (direction === 'next') {
        if (currentDateIndex + 10 >= dates.length) {
            // Generate 10 more dates if at the end
            const newDates = addDates(dates.length, dates.length + 10);
            setDates([...dates, ...newDates]);
        }
        setCurrentDateIndex(currentDateIndex + 10);
    } else if (direction === 'prev') {
        if (currentDateIndex === 0) {
            // Generate 10 more dates in the past if at the start
            const newDates = addDates(-10, 0);
            setDates([...newDates, ...dates]);
            setCurrentDateIndex(10); // Adjust to keep the view centered on the new dates
        } else {
            setCurrentDateIndex(currentDateIndex - 10);
        }
    }
};

    return (
      <div>
        
      <div className="calendar1-container">
        <div className="calendar1-header">
            <h3>Live Air Pax Calendar</h3>
            <div className="search-bar">
                <input type="text" placeholder="Search by Travel Date" />
                <button onClick={() => navigateDates('prev')}>&lt;</button>
                <button onClick={() => navigateDates('next')}>&gt;</button>
            </div>
        </div>
        <table className="dates-table">
            <thead>
                <tr>
                    {dates.slice(currentDateIndex, currentDateIndex + 10).map((item, index) => (
                        <th key={index} className={`date-box ${item.isToday ? 'highlighted' : ''}`}>
                            {item.day}
                            <div className={`date-circle ${item.isToday ? 'highlighted-circle' : ''}`}>{item.date}</div>
                            <div>{item.monthYear}</div>
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                <tr>
                    {dates.slice(currentDateIndex, currentDateIndex + 10).map((_, index) => (
                        <td key={index}>
                            <div>-</div>
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
      </div>
      </div>
    );
};

export default AirPaxCalendar;
